import React, { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import api from "@/lib/api";

// Fetches an authenticated file from the backend as a blob and renders it.
export default function AuthImage({ path, alt = "", className = "", fallbackText }) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!path) return;
    let url;
    let active = true;
    api
      .get(`/files/${path}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      })
      .catch(() => active && setError(true));
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (error || !path)
    return (
      <div className={`flex flex-col items-center justify-center bg-[#0a0a0a] text-zinc-700 ${className}`}>
        <ImageOff size={22} />
        {fallbackText && <span className="text-[10px] font-mono mt-1">{fallbackText}</span>}
      </div>
    );

  if (!src)
    return <div className={`bg-[#0a0a0a] animate-pulse ${className}`} />;

  return <img src={src} alt={alt} className={className} />;
}
